import common from './common';
import validation from './validation';
import translation from './translation';

export default {
  common,
  validation,
  translation,
};
